import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { contactSupport } from "@src/utils/contactSupport";

// Shown wherever a post-purchase upsell is blocked because the store doesn't
// have it turned on: the create card, Atlas, and the Start buttons.
export const PostPurchaseNoAccessMessage = () => (
  <IgTypography>
    Post-purchase upsells aren't turned on for this store.{" "}
    <IgLink
      onClick={() => {
        contactSupport();
      }}
    >
      Contact support
    </IgLink>{" "}
    to turn them on.
  </IgTypography>
);
